import script from "./CusCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./CusCheck.vue?vue&type=script&setup=true&lang=js"

import "./CusCheck.vue?vue&type=style&index=0&id=43aad6da&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43aad6da"]])

export default __exports__